import { getActiveOwnerPortalPlatform } from './owner-portal';

const location = typeof window === 'undefined' ? undefined : window.location;
const locationHost = location?.host ?? '';
const locationHostname = location?.hostname ?? '';
const locationHref = location?.href ?? '';

export const GRAPHQL_URI = 'https://railway.hasura.vrplatform.app/v1/graphql';

export const AUTH_REDIRECT_URL = import.meta.env.DEV
  ? 'https://tolocalhost.com/verification'
  : `https://${locationHost || 'portal.vrplatform.app'}/verification`;

export const NEW_SIGN_IN = false;

type Platform = 'finalytic' | 'vrplatform';

export const PLATFORM: Platform =
  (import.meta.env.VITE_PLATFORM_NAME as Platform) || 'vrplatform';

// Google Maps api key

export const STATUS_PAGE =
  PLATFORM === 'finalytic'
    ? 'https://status.finalytic.io'
    : 'https://status.vrplatform.app';

export const isLocalhost =
  locationHost.includes('localhost') || locationHost.includes('127.0.0.1');
export function isProductionHostname(hostname: string) {
  return hostname === 'portal.vrplatform.app';
}

/**
 * Production is the platform hostname, or a customer owner portal whose
 * validated registration points at the production primary domain. An
 * unrecognised hostname is never production on its own.
 */
export function isProductionEnvironment() {
  return (
    isProductionHostname(locationHostname) ||
    getActiveOwnerPortalPlatform() === 'production'
  );
}
export function isStagingEnvironment() {
  return (
    locationHostname === 'staging.portal.vrplatform.app' ||
    getActiveOwnerPortalPlatform() === 'staging'
  );
}
export const isExtension = locationHref.startsWith('chrome-extension');
export const isStorybook = import.meta.env.VITE_STORYBOOK === 'true';
